export default {
    id:"id",
    resume:"path",
    trainingField:"training_field",
    createdAt:"created_at",
    "trainer.name": "users.name",
    "trainer.email": "users.email",
    "trainer.phoneNumber": "users.phone_number",
}